import type { FaireProductEntity } from "../../entity_types/product";

export const p_ct2vc4y8gu: FaireProductEntity = {
  token: "p_ct2vc4y8gu",
  type: "product",
  name: "Gold Filled Flower Charm Enamel Blossom Pendant CP2328",
  brandToken: "b_7ef699gcdg",
  brandName: "Beads Creation",
  imageUrl:
    "https://cdn.faire.com/fastly/5a606edf1014a802319fed7591227fa2f9f119b477591d703fbd335ac3440068.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d2279806a7687d9534ebb6c28089a490eaa8bdf5e801182a6b89e0d6ed03f40d.webp",
    "https://cdn.faire.com/fastly/4a6df4fa161bd25a6c96f627a80a48da9b297fc7538044fe7f69e4beda8eeb6c.webp",
    "https://cdn.faire.com/fastly/4cf1707731fb51bb2b5a62cc3ede6f05e90a2a3589b7ca675948cdbd2f37ac6a.webp",
    "https://cdn.faire.com/fastly/ee6341cbd4270ee22dbad34b222b023f743a2cb5d240e0bc9bdd096e4c46f6e2.webp",
    "https://cdn.faire.com/fastly/061fdb41fd015dce3bd57714fd7e2a32a72b7fdaca3763cbd70f080688236611.webp",
    "https://cdn.faire.com/fastly/2b9a6ff5579aaabb9ba954adf9c4e2b8e72b67b4b40e9a712673603c91a2fae3.webp",
    "https://cdn.faire.com/fastly/18a7c0690ba9b8e005cec092b57293df38625893bfda06aff913a9cd0a39639d.webp",
    "https://cdn.faire.com/fastly/7ede4ce19c1943778dea3cc2d11e57eb1b02a138bf2e7288e648bc5ddc5ef299.webp",
    "https://cdn.faire.com/fastly/c144d3f26d0c9dc31af92b08cc4ff1357eaa9bc9f3623bb998d985fe7b4d4314.webp",
  ],
  priceDollars: 2.76,
  description:
    "Description:\nMaterial: Copper Based with 18K Gold Filled, Enamel\nSize: 17x14mm\nQTY: 1PC\n\nPLEASE NOTE : \n\nThese beautiful pieces are crafted with delicate materials and are not designed for permanent wear or water resistance.\nTo ensure their lasting beauty, please follow the guidelines outlined below.\n\nCARE INSTRUCTIONS :\n\n- Keep your jewelry away from showers, pools, and workouts to prevent water damage.\n- Take off your jewelry before sleeping or exercise to avoid any wear and tear.\n- Apply makeup, lotions, and perfumes before putting on your jewelry.\n- Household cleaners and chemicals can be damaging. Keep your jewelry far from them.\n- Gently polish with a soft, lint-free cloth after wearing. Store in a sealed bag or box in a cool, dry place.",
  tags: [],
  msrpDollars: 5.51,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T20:34:28.452Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
